module.exports = __webpack_public_path__ + "static/media/welcome-page-img-v2.609cf3de.jpg";